export default {"src":"https://cdn.jetlend.ru/_next/static/media/up-right-arrow--black.2cdf2447.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};